import socket from '@/plugins/socket'

export default {
  namespaced: true,
  state: {
    list: [],
    filtered: []
  },
  mutations: {
    init: (state, datas) => { state.list = datas.sort((a, b) => a.nameFr.localeCompare(b.nameFr)) },
    filtered: (state, data) => { state.filtered = data.map(item => item.id) }
  },
  actions: {
    init (state) { socket.get('SportSportCompetition', 'Sport/Competition/init') },
    set (state, data) {
      state.state.filtered = []
      const parameters = {
        include: [
          { column: 'providerId' },
          { column: 'sportId' },
          { column: 'areaId' }
        ]
      }
      if (data.areaId && data.areaId > 0) {
        parameters.areaId = data.areaId
      }
      if (data.seasonId && data.seasonId > 0) {
        parameters['SportSportCompetitionseason.seasonId'] = data.seasonId
        parameters.joinr = ['SportSportCompetitionseason.competitionId']
      }

      socket.get('SportSportCompetition', 'Sport/Competition/filtered', parameters)
    }
  },
  getters: {
    list: (state) => state.list,
    filtered: (state) => state.filtered,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
